module.exports = __webpack_public_path__ + "media/images/logo_wb-ff0552c265907b73ba7d14235e81f093.png";